module.exports = __webpack_public_path__ + "img/svg/chip-dec58568.svg";